module.exports = __webpack_public_path__ + "img/img-antros.7242726c.webp";